// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON = "Koupit";
export const BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON_NOTE = "Pomoc\u00ed tla\u010d\u00edtka \"Koupit\" m\u016f\u017ee\u0161 vyu\u017e\u00edt zv\u00fdhodn\u011bnou dopravu, zbo\u017e\u00ed si ihned rezervuje\u0161 a nikdo t\u011b nep\u0159edb\u011bhne";
export const BAZAAR_PRODUCT_IS_RESERVED = "Toto zbo\u017e\u00ed je rezervovan\u00e9.|Z\u00e1jemce vyu\u017eil zv\u00fdhodn\u011bnou dopravu.";
export const BZ2_JUST_SEND_MESSAGE = "Po\u0161li zpr\u00e1vu";
export const BZ2_SEND_MESSAGE_ANONYMOUS = "Po\u0161li zpr\u00e1vu prodejci";
